import { rootSelector } from '@/redux/root/root.selectors';
import { createSelector } from '@reduxjs/toolkit';
import { projectDataSelector, projectIdSelector } from '@/redux/project/project.selectors';
import { hasPrivilegeToObject } from '@/redux/user/user.utils';
import { Project, UserPrivilege } from '@/types/models';
import { USER_ROLE } from '@/constants/user';

export const userSelector = createSelector(rootSelector, state => state.user);

export const authenticatedUserSelector = createSelector(userSelector, state => state.authenticated);
export const loadingUserSelector = createSelector(userSelector, state => state.loading);
export const loginUserSelector = createSelector(userSelector, state => state.login);
export const userRoleSelector = createSelector(userSelector, state => state.role);
export const userPrivilegesSelector = createSelector(
  userSelector,
  state => state.userData?.privileges || [],
);
export const hasPrivilegeToWriteProjectSelector = createSelector(
  userPrivilegesSelector,
  projectIdSelector,
  userRoleSelector,
  projectDataSelector,
  (
    userPrivileges: UserPrivilege[],
    projectId: string | undefined,
    role: string | null,
    project: Project | undefined,
  ): boolean => {
    if (!projectId || !role) {
      return false;
    }
    return (
      (role === USER_ROLE.ADMIN ||
        (role === USER_ROLE.CURATOR &&
          hasPrivilegeToObject(userPrivileges, 'READ_PROJECT', projectId))) &&
      !(project?.readonly || false)
    );
  },
);
export const userTokenSelector = createSelector(userSelector, state => state.token);
